var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnBtnCustomizePressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8L13 8M3 8L13 8",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13V3M8 13V3",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50391 3.5H6.49609L8 1.7627L9.50391 3.5Z",
    fill: "#172664",
    stroke: "#172664"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49609 12.5H9.50391L8 14.2373L6.49609 12.5Z",
    fill: "#172664",
    stroke: "#172664"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 6.49609L3.5 9.50391L1.7627 8L3.5 6.49609Z",
    fill: "#172664",
    stroke: "#172664"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.50391V6.49609L14.2373 8L12.5 9.50391Z",
    fill: "#172664",
    stroke: "#172664"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnBtnCustomizePressed);
export default __webpack_public_path__ + "static/media/icn_btn_customize_pressed.55e2eb0c105819984ade9f7864249dc2.svg";
export { ForwardRef as ReactComponent };